export default __webpack_public_path__ + "7fd5ef2fe1d50975bc99b77d9894f1cb.png";